// Module
var code = "<configurable-grid-form-view config=\"progressiveMachinesEditController.configurableGridFormViewConfig\"> </configurable-grid-form-view> ";
// Exports
export default code;